import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import './TaskSubNav.css';
import { DSIcon } from '../design-system/primitives';

const BASE_TABS = [
  { path: '/tasks', icon: <DSIcon name="target" />, label: 'Tasks', match: (p) => p === '/tasks' || (p.startsWith('/tasks/') && /^\/tasks\/\d+/.test(p)) },
  { path: '/tasks/my-suggestions', icon: <DSIcon name="note" />, label: 'Suggestions', match: (p) => p.startsWith('/tasks/my-suggestions') || p.startsWith('/tasks/suggest') }
];

const MANAGE_PATH_PREFIXES = ['/tasks/needs-attention', '/tasks/templates', '/tasks/walkthrough', '/tasks/leaderboard', '/tasks/reporting'];

const DELEGATE_TABS = [
  {
    path: '/tasks/needs-attention',
    icon: <DSIcon name="settings" />,
    label: 'Manage',
    match: (p) => MANAGE_PATH_PREFIXES.some((prefix) => p.startsWith(prefix))
  }
];

function TaskSubNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();
  const isDelegate = currentUser?.role === 'admin' || (currentUser?.featureRoles || []).includes('task_management');

  const tabs = isDelegate ? [...BASE_TABS, ...DELEGATE_TABS] : BASE_TABS;

  return (
    <nav className="tm-subnav">
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        return (
          <button
            key={tab.path}
            type="button"
            className={`tm-subnav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="tm-subnav-icon">{tab.icon}</span>
            <span className="tm-subnav-label">{tab.label}</span>
            {isActive && <span className="tm-subnav-dot" />}
          </button>
        );
      })}
    </nav>
  );
}

export default TaskSubNav;
